var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4727 1.26172L12.7227 12.6094C12.6953 12.8828 12.5312 13.1289 12.2852 13.2656C12.1484 13.3203 12.0117 13.375 11.8477 13.375C11.7383 13.375 11.6289 13.3477 11.5195 13.293L8.18359 11.8984L6.78906 13.9766C6.67969 14.168 6.48828 14.25 6.29688 14.25C5.99609 14.25 5.75 14.0039 5.75 13.7031V11.0781C5.75 10.8594 5.80469 10.668 5.91406 10.5312L11.875 2.875L3.83594 10.1211L1.01953 8.94531C0.71875 8.80859 0.5 8.53516 0.5 8.17969C0.472656 7.79688 0.636719 7.52344 0.9375 7.35938L13.1875 0.386719C13.4609 0.222656 13.8438 0.222656 14.1172 0.414062C14.3906 0.605469 14.5273 0.933594 14.4727 1.26172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignImage);
export default __webpack_public_path__ + "static/media/AssignImage.861237f24e02298be89d2fbcfd6eb978.svg";
export { ForwardRef as ReactComponent };